import trLang from "./entries/tr_TR";
import enLang from "./entries/en-US";
import zhLang from "./entries/zh-Hans-CN";
import arLang from "./entries/ar_SA";
import itLang from "./entries/it_IT";
import esLang from "./entries/es_ES";
import frLang from "./entries/fr_FR";
import jaLang from "./entries/ja_JP";
import ptLang from "./entries/pt_PT";
import ruLang from "./entries/ru_RU";
import idLang from "./entries/id_ID";
import deLang from "./entries/de_DE";
import hiLang from "./entries/hi_IN";
import azLang from "./entries/az_AZ";
import {addLocaleData} from "react-intl";

const AppLocale = {
  tr: trLang,
  en: enLang,
  zh: zhLang,
  ar: arLang,
  it: itLang,
  es: esLang,
  fr: frLang,
  ja: jaLang,
  pt: ptLang,
  ru: ruLang,
  id: idLang,
  de: deLang,
  hi: hiLang,
  az: azLang
};

Object.keys(AppLocale).forEach((key) => {
  addLocaleData(AppLocale[key].data);
});

// Kaydedilmis ayar eski/bilinmeyen bir dil kodu tasiyorsa uygulama cokmesin.
export const resolveAppLocale = (locale) => {
  const key = typeof locale === "string" ? locale.toLowerCase() : "";
  return AppLocale[key] || AppLocale[key.split("-")[0]] || AppLocale.tr;
};

export default AppLocale;
